import React from "react";
import green from "../images/green.svg";
import pink from "../images/pink.svg";
import white from "../images/white.svg";
import yellow from "../images/yellow.svg";
import orange from "../images/orange.svg";

const TeamCard = ({ img, name, title, color }) => {
  return (
    <div className="flex flex-col mx-auto gap-[20px] h-[430px] py-[36px] card px-[60px] relative overflow-hidden max-w-[400px]">
      <img
        src={
          color === "green"
            ? green
            : color === "white"
            ? white
            : color === "pink"
            ? pink
            : color === "orange"
            ? orange
            : yellow
        }
        alt=""
        className="absolute -z-10 scale-[3]"
      />
      <img
        src={img}
        alt=""
        className="rounded-full w-[177px] h-[177px] mx-auto"
      />
      <p className="text-[24px] font-[800] text-center font-robo">{name}</p>
      <p className="text-[24px] font-[300] text-center mb-[20px] font-robo">
        {title}
      </p>
    </div>
  );
};

export default TeamCard;
